import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AutenticacionService } from '../../../shared/services/autenticacion/autenticacion.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  innerWidth:number;
  tab = 0;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private autentificacionService: AutenticacionService
  ) {
    // redirect to home if already logged in
    if (this.autentificacionService.currentUserValue) {
      this.router.navigate(['/']);
    }
    this.innerWidth = window.innerWidth;
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  async onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      Swal.fire("Oops!..","Debe llenar los campos","error")
      this.error = 'usuario/contraseña incorrecto';
      this.loading = false;
      return;
    }

    this.loading = true;
    let usuarioLogin = {
      strUsuario: this.f['username'].value,
      strPassword: this.f['password'].value
    }

    let respuesta = await this.autentificacionService.login(usuarioLogin);
   // let respuesta=true
    if (respuesta) {
      this.router.navigate(['/admin/']);
    } else {
      Swal.fire("Oops!..","El usuario o la contraseña no son válidos","error")
      this.error = 'usuario/contraseña incorrecto';
      this.loading = false;
    }
  }
  onResize(event) {

    this.innerWidth = window.innerWidth;
  }



}
